import { useRouter, usePathname } from 'next/navigation';
import { menuData, getMenuId } from './menu';
import './Navigation.scss';

const Navigation = () => {
	const router = useRouter();
	const pathname = usePathname();
	const bigMenu = getMenuId(pathname || '/', menuData, 1); // 当前选中的一级菜单的key
	const initMenu = getMenuId(pathname || '/', menuData); // 当前选中的菜单的key

	const toPath = path => {
		if (path) {
			router.push(`${path}`);
		}
	};

	const renderDom = () => {
		return menuData.map(item => {
			return (
				<li
					key={item.key}
					className={`navmenu1${item.key === bigMenu ? ' menuselected' : ''}`}
					onClick={() => {
						toPath(item.path);
					}}
				>
					<div>
						{item.label}
						{item.children && item.children.length > 0 ? <div className="jiantou"></div> : null}
					</div>
					{item.children && item.children.length > 0 ? childDom(item) : null}
				</li>
			);
		});
	};

	const childDom = item => {
		return (
			<div className="nav-childDiv">
				<ul>
					{item.children.map(item2 => {
						return (
							<li
								onClick={e => {
									toPath(item2.path);
								}}
								key={item2.key}
								className={`navmenu2 ${item2.key === initMenu ? ' childselected' : ''}`}
							>
								{item2.label}
							</li>
						);
					})}
				</ul>
			</div>
		);
	};

	return (
		<div className="menunav">
			<ul>{renderDom(menuData)}</ul>
		</div>
	);
};

export default Navigation;
